export default "__VITE_ASSET__PiQdK570__"